import { HttpClient } from '@angular/common/http';
import { HostListener, Injectable, WritableSignal, signal } from '@angular/core';
import { Router } from '@angular/router';
import { TOAST } from '@commoncore/constants/ToastMessages';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { PasswordEncryptorUtil } from '@mainrepo/app/core/utils/PasswordEncryptorUtil';
import { TranslateService } from '@ngx-translate/core';
import Bowser from 'bowser';
import { BehaviorSubject } from 'rxjs';
import { GlobalClassInstance } from '../constants/GlobalClass';
import { LANGUAGE_SUPPORT, SUNSET_SUNRISE, THEMES } from '../constants/LandingConstants';
import { ContainerHeightCalculatorService } from './container-height-calculator.service';


declare var jQuery: any
declare var jQuery: any;
declare var $:any;


@Injectable({
  providedIn: 'root'
})
export class UniversalService {

  public targetUrl:any="";
  public invokeRefresh:boolean=false;
  public entHeaderTitle:String = "";
  public showCreateFolderModal:boolean=false;
  public showCreateAlbumModal:boolean=false;
  public activeRepo:String;
  public virtualGridEnabled:boolean = true;
  public twoFAHash:String ;
  public enc2FAHash:String ;
  public tempPassPhrase:String ;
  public otpReceivedOn:String ;
  public isDisable2FAInprocess:boolean = false;
  public isPassphraseReset:boolean = false;
  public static pingcall:any;
  public static qrLoginInterval:any;
	public static qrValidationInterval:any;
  public static refreshShareSession:any;
  public isRefreshShareEnabled:boolean = false;
  public shardKey:string="";
  public connectionStatus: boolean= true;
  public showSuccessToastMessage:boolean= false;
  public showSuccessThirdPartyToastMessage:boolean= false;
  public showErrorToastMessage:boolean = false;
  public showWarningToastMessage:boolean = false;
  public thirdPartyEmail:string = "";
  public toastMessage:string = "";
  public showViewButton:boolean = false;
  public OtpInterval:any;
  public mobileSelectionModeOn:boolean = false;
  public isMobileDevice:boolean = false;
  public rowHeightTolerance:any;
  public iOSdevice:any;
  public chromeOS:boolean = false;
  public userLoggedIn:boolean=false;

public openFolderContent:boolean=false;
public audiofileslistsize:number = 0;
public docfileslistsize:number = 0;
public firstTimeHit:boolean=false;
public objectsToBeAdded:any;
public sideNavVisible:boolean;
// public nextLink:string;
public selectedFile:any;
public showTopMenu:boolean=false;
// public showEverOptions:boolean=false;
public showFileInfo:boolean=false;
public listView: boolean = false;
public mediaFiles:boolean = false;
public recentFilesListView = false;
public selectedNodes: any = [];
public showPreview: boolean = false;
public filesToBeAdded: any = [];
public sharedImages:any=[];
public sharedAudios:any=[];
public sharedVideos:any=[];
public sharedDocs:any=[];
// public profileUrl:any;
public sharingAlbumFiles :boolean = false;
public currentTab:string = "";
public currentFileOpsWrapper = "";
public selectedTab :string = "";
public purchaseModalType:string="";
public planPurchaseInitiated:boolean = false;
public docEditSupportedExtensions : any;
public MSOfficeSupportedInModule : boolean = false;
public showWhatsSearchable : boolean = false;
public manageVersionsSupportedInModule : boolean = false;
public isShortcutKeyAllowedForOperation: boolean = false;
public photoEditSupportedInModule: boolean = false;
public videoThumbnailPreviewSupportedInModule: boolean = false;
public allowPhotoEditInViewBasedOnAccessRights : boolean = true;
public emptyTabViewRequiresMenu : boolean = false;
public viewIsTabOriented : boolean = false;
public hideTopMenu : boolean = false; // this flag is used to control when the multi select is enabled but the topmenu should be hidden
// public sortedPhotos:any = [];
// public sortedAudios:any = [];
// public sortedVideos:any = [];
// public sortedDocs:any = [];
public sharedRoot:any = [];
public currentFiles:any;
// public jioIdLogin = new BroadcastChannel("jioid_sso_token_broadcast");
public shareViewTypeGridName: string = "gridView";
public shareViewTypeListName: string = "listView";
public shareViewType: string = "";


//public sharePublicSortPropName: string = "";
public sharePublicSort: string = "";
public sharePublicSortByDate: string = "";
public sortIcon: string = "NeueDownTraffic";

//public sharePublicSortByName: string = "%2BobjectName";
//public sharePublicSortOrder: string = "";

//Uploaded date sorting
public isSortByUploadDate:boolean = false;
public sharePublicSortByUploadDate: string = "";

public scrollToTopIcon:boolean  = false;
// public scrollToTopPix:number = 0;
// public scrollHeaderPix:number = 0;
// public scrollApiInvokeEligible:boolean  = true;

public foldersArray:any = [];
public showMobFileInfoPanel:boolean = false;

public mobileSelectedObj:any=[];
public recentMobileSelectedObj:any=[];
public objectsPreviewArray :any =[];
public fetchAllRecentFiles:boolean = false;
public isMobileFilePreviewOpen:boolean = false;
public showMobOptionMenu:boolean = false;
public sortByNameArray:any=[];
public sortByDateArray:any=[];
public allFilesnextLink:any ='';
public isMobileTopMoreOptionMenu = false;
public isDesktopSelectionModeOn = false;
public showAddToJioCloudOnTopMenu:boolean=true;
public isObjectRightClick:boolean=false;
public showContextMenu:boolean = false;
public viewButtonUrl:string="";
public emptyFolder:boolean = false;
public showLoader:boolean = false;
public selectionMode:boolean = false;
public errorMessage:string = '';
public objectSelected: boolean = false;
public isServerError: boolean = false;
public selectedFolder: any;
public isSupprtedBrowser:boolean = true;
public isWebpSupported:boolean = false;
public isGIFSupported:boolean = false;
public hideTabs:boolean = false;
public source:string="";
public insideFolder:boolean = false;
public showJustifiedLayout:boolean= false;
public videoPreviewUrl:any;
public shareKey:string="";
public loadGridView :boolean  = false;
public nameSort:boolean  = false;
public showSortButtons:boolean = false;
public showAutoSuggestion:boolean = false;
public showShareSortingOptions:boolean = false;
public showPeopleSortMenu:boolean = false;
public iframeLogin : boolean = false;
public showLeftFullMenu:boolean = false;
public summaryData: any;
public popUpToBeOpened:string = "";
public emptyTab : boolean = false;
public emptyTrash:boolean = false;
public emptyShared:boolean = false;
public emptySharedLink:boolean = false;
public emptyFav:boolean = false;
public emptyContact:boolean = false;
public allTypesOfObj:any = [];

public showShareWithPeople:boolean = false;
public showEnhancedShareLink:boolean = false;
public loadManageAccessComponent:boolean = false;
public showManageAccess:boolean = false;
public isAnyChange:boolean = false;
public lang: string = LANGUAGE_SUPPORT[0].code;
  private themeAppearance: string = THEMES.THEME_LIGHT;
  public isDarkTheme;
  public contextMenu_Share :any;
  public contextMenu_MainRepo :any;
  public myFiles_default_ContextMenu:any;
  public albums_default_ContextMenu:any;
  public topMenu_Share :any;
  public topMenu_MainRepo :any;
  public topMenuMobile_Share :any;
  public topMenuMobile_MainRepo :any;
  public topMenuMobile : any;
  public FileInfo:any;
  public contextMenuOptions = [];
  public contextMenuMoreOptions = [];
  public topMenuOptions = [];
  public moreOptionsOnTopMenu = [];
  public middleMenuOptionsMobile = [];
  public bottomMenuOptionsMobile = [];
  public moreOptionsOnMobileClicked = false;
  public moreOptionsSubMenu = [];
  public currentAlbum: any;
  public currentMemory : any;
  public openMoreOptions:boolean = false;
  public openMoreOptionsContextMenu:boolean = false;
  public totalCountOfFolders:number;

  public showMiniPlayer:boolean = false;
  public showFullViewAudioPlayer:boolean = false;
  public selectedAudioFile:any;
  public audioPreview:boolean = false;
  public player:any;
  
  public selectedPreviewFile:any;
  public selectedPreviewFileIndex :any;
  public showAudioWaves: boolean = true;
  public showAudioPreviewForFilter: boolean = false;
  public mobilePlayList = [];
  public showMobilePlayList:boolean = false;
  public songPosTime: number = 0;
  public playAudioFromStart:boolean = true;
  public isManualPause:boolean = false;
  public isManualVideoPause:boolean = false;
  public showDirectMiniPlayer:boolean = false;

  public recentFilesDataPreview = false;
  public listIndexOnPreview:any;
  public audioListIndexOnPreview:any;
  public mobFolderShownCount:any = 3;
  public priviewFileCount: number =0;
  public priviewAudioFileCount: number =0;
  public recentFilesPreviewArray = [];
  public showInfoDetails:boolean = false;
  public showInfoActivity:boolean = false;
  public showInfoComments:boolean = false;
  public onMoveFolderCreationSameFolder:boolean = false;
  public browserDetails:any=[];
  public tabClicked:any="";
  public popUpTabClicked:any="";
  public headingTitle : WritableSignal<string> = signal("");
  public hasEditAccess:boolean = false;
  public refreshTokenInprocess:boolean = false
  public selectionNodeNotNeedtoclear:boolean = false
  public isPingEnabled:boolean = false;
  public movePopupOpenFolderKey:any=[]
  public profileIconPath:any;
  public userLandingLoggedIn:boolean =false;
  public hideLeftMenu:boolean = false;
  public isShowEmailVerifyModal:boolean =false;
  public showRequestAccessScreen:boolean = false;
  public redirectShareLink : string = "";
  public showGrantAccessScreen:boolean = false;
  public uploadStorageFullError: boolean = false;
  public MarkNewObjArray:any = [];
  public selectedRowAfterUpload:any =[];

  public audioPreviewOpenFromMiniPlayer:boolean = false;
  public updatedObject:any ;
  public videoClapperRunning: boolean = false;
  public slectedRowId:any;
  public firstName:any;
  public lastName:any;
  public emailId:any;
  public audioClapperRunning: boolean = false;
  public atPreviewfolderCount: number = 0;
  public currentViewDataSize: number = 0;
  public selectedFileOldName: string = "";
  public ignoreUnAuthorizedError:boolean = false;
  public deletedFileShare:boolean = false;
  public uploadButtonClicked:boolean = false;
  public showLangDropdown:boolean = true;
  public showThemeSwitch:boolean = true;
  public isMobileShareOptionClicked:boolean = false;
  public showShareCreatedSortShared = "";
  public showJioAdds:boolean = false;
  public isUploadFromShare:boolean = false;
  public isUploadFromRecentlyUploadedSection:boolean = false;

  public isAlbumUpload:boolean = false;
  public noAlbumComments:boolean = false;
  public commentLimit = 0;
  public isAlbumsView:boolean = false;
  public lastComment:any
  public contactOffet: number = 0;
  public nextPageDate: any;
  public contactChunkSize : number = 30
  public contactSearchValue: any='';
  public hideContactSearchBox: boolean=false;
  public showMoreOptionsOnContacts : boolean = true;
  public showCoverPicModal:boolean = false;
  public updatedcoverPicUrl:string = '';
  public coverPicObj:any = [];
  public showFeaturesForEntUsers:boolean = false;
  public isAllowPublicShare: boolean = true;
  public isAllowExtPrivateShare: boolean = false;
  public isAllowEnternalPrivateShare: boolean = false;
  // public contactImageBox: boolean=false;

  public showMobAlbumInfoPanel:boolean = false
  hideEditAlbumNameBox:boolean = true
  hideEditAlbumDescBox:boolean = true
  SHORT_MONTH_NAMES:any = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  LONG_MONTH_NAMES:any = ["January","February","March","April","May","June","July","August","September","October","November","December"];
  public finalLastUpdatedDateOfResponse:any = 0;
  public show2FApopUp:boolean = false;
  public passPhraseValidationSuccess:boolean = false;
  public referralQuotaDetails: any;
  public showPassPhraseReset:boolean = false;
  public lockTimer:any;
  public isStreaming:boolean = false;
  public forgotPassPhraseModalOpned:boolean = false;
  public isTroubledInSigningInFlowOn:boolean =false;
  public showTroubledSignInLink: boolean = false;

  public showRecoverpopUp:boolean = false;  //scren1 notyouraccount
  public showRecoverVerifyemailpopUp:boolean = false; //scren1 verifyemail
  //public recoverSendOTPpopUp:boolean = false; //otp screen
  public recoverVerifyOTPpopUp:boolean = false;
  //public recoverErrorPopUp:boolean = false;
  public customerTroubleLogin:boolean = false;
  public isUserOnSharedLinkByMe = false;
  public isRequestedUrlExpired = false;
  public  recipientsObjRights= {
    "canDelete": true,
    "canCopy": true,
    "canDownload": true,
    "canEdit": true,
    "canRename": true,
    "canShare": true,
    "canView": true,
    "canAdd": true,
    "canRemove": true,
    "canComment": true
  };
  public OPERATIONS_WHICH_NEED_UI_UPDATE = [
    "Copy",
    "Private share",
    "Delete",
    "Remove",
    "Rename",
    "Move",
    "Move to Private Folder",
    "Favorite",
    "Add Hashtag",
    "Remove Favorite",
    "Remove from Album",
    "Move out of Private Folder",
    "Remove Result(s)",
    "Set as cover photo",
    "Use as feature photo",
    'Mark Favorite',
    "Unmark Favorite",
    "Share link",
    "Share"
  ]

  public collabShareObject = [];

  public inAppWebViewOpened:boolean = false;
  public onFullScreen:boolean = false;
  socialEmailAlreadyVerified:boolean = false;
  cTime:any;
  showAlbumCommentsModal:boolean = false;
  recentAlbumSCFilesPreviewArray = []
  public isPreviewOpenFromSearchDropdown:boolean = false;
  showSearchBar:boolean= false;
  showContactSearch:boolean = false;
  searchType:string = 'global';
  containsOnlyPhotos:boolean = false;
  allowUpload:boolean = false;
  allowMoveDrag:boolean = false;
  showBreadCrumbsInsideTabContent : boolean = false;
  viewContainsFolders : boolean = false;
  public promoWebViewOpened:boolean = false;
  isViewFileClicked:boolean = false;
  showPromotionsList:boolean = false;
  myBackupRootFolderKey:any;
  isUnFavInvoked:boolean = false;
  /* */
  createFolderApiResponse:any
  currentOpenIndexDBStoreforFile:any
  currentOpenIndexDBStoreforolder:any
  store_AllFilesMetadata_Grid_Name_Asc:number = 0;
  store_AllFilesMetadata_Grid_Date_Desc:number = 0;
  store_AllFiles_FolderMetadata_Name_Asc:number = 0;
  store_AllFiles_FolderMetadata_Date_Desc:number = 0;
  store_AllFilesMetadata_List_Name_Asc:number = 0;
  store_AllFilesMetadata_List_Name_Desc:number = 0;
  store_AllFilesMetadata_List_Date_Desc:number = 0;
  store_AllFilesMetadata_List_Size_Asc:number = 0;
  store_AllFilesMetadata_List_Size_Desc:number = 0;
  store_AllFilesMetadata_List_Type_Asc:number = 0;
  store_AllFilesMetadata_List_Type_Desc:number = 0;
  store_PhotosMetadata_ObjectName:number = 0;
  store_PhotosMetadata_FileCreatedDate:number = 0;
  store_VideosMetadata_ObjectName:number = 0;
  store_VideosMetadata_FileCreatedDate:number = 0;
  store_ContactsStore_Asc:number = 0;
  store_ContactsStore_Dsc:number = 0;
  store_AlbumsList:number = 0;
  store_DocumentMetadata_Name_Asc:number = 0;
  store_DocumentMetadata_Name_Desc:number = 0;
  store_DocumentMetadata_Size_Asc:number = 0;
  store_DocumentMetadata_Size_Desc:number = 0;
  store_DocumentMetadata_Type_Asc:number = 0;
  store_DocumentMetadata_Type_Desc:number = 0;
  store_DocumentMetadata_FileCreatedDate_Asc:number = 0;
  store_DocumentMetadata_FileCreatedDate_Desc:number = 0;
  store_DocumentMetadata_CreatedDate_Asc:number = 0;
  store_DocumentMetadata_CreatedDate_Desc:number = 0;
  store_AudiosMetadata_Name_Asc:number = 0;
  store_AudiosMetadata_Name_Desc:number = 0;
  store_AudiosMetadata_FileCreatedDate_Asc:number = 0;
  store_AudiosMetadata_FileCreatedDate_Desc:number = 0;
  store_AudiosMetadata_CreatedDate_Asc:number = 0;
  store_AudiosMetadata_CreatedDate_Desc:number = 0;

  photoLowerBound:number = 0;
  photoVisibleData:number = 0;
  
  downloadInProgress: boolean = false;
  downloadQueue: Array<any> = [];
  //downloadQueue: Array<any> = [{"key":"1648548887879","items":[{"objectKey":"c83ee5fae0f94086b7ea6524b4557353"},{"objectKey":"e0a72237bae845238dc9440fca76f478"},{"objectKey":"85c7cf85743e4515bcdf9cb688fe88f3"}],"statusText":"Download cancelled","cancelDownload":true}]
  cancelDownload = false;
  public  uploadCompleted = true;
  hideDeleteForPublicPreviewShare : Boolean = false;
  leftMenu:any;
  isUnivSharelink : Boolean = false;
  openCreateShareLink : boolean = false;
  public selectedFace:any;
  public folderSpecificDrag:boolean = false;
  public destinationFolder:any={"objectName":"JioAICloud"};
  public inviteAcceptedUserCount: number = 0;
  dragDropWithinApp : boolean = false;
  allNodesDataFromListView:any;
  pendingInvite: boolean = false;
  showEntNotifications : boolean = false;
  entReportDaysCount :any = 1;
  showApplyCouponModal : boolean = true;
  applyCouponSuccess : boolean = false;
  testVariable:any;
  isRecentPanelSelected:boolean = false;
  public contactSearchValidationMessage:string = "Please enter at least 2 characters to search for a contact";

  rootFolderNameNew : any = "All Files";
  rootFolderNameOld : any = "...";
  rootFolderNameSharedfiles : any = "Shared Files";
  rootTeamFolderName = "Team Folders";
  showTabSlider:boolean = false;
  isTourON:boolean= false;
  showTourForAllJioCloudUsr: boolean = false;
  showEntTourVideoModal:boolean = false;
  showEntTourPDF:boolean = false;
  showEntTourVideo:boolean = false;
  ent_tour_allfile_status: any;
  ent_tour_entreopo_status: any;
  ent_tour_noadmin_status: any;
  loginType:any = "JioId";
  currentTeamFolder:any = null;
  tfPermissionType:string = "R";
  //baseFolderTfKey:string = "";
  allTeamsFoldersArray:any = [];
  operationInProgress = false;
  showTopMoreOptionsOnMobile:boolean = false;
  isManageTeamFolderMembers:boolean = false;

  refreshIntervalTimerForThirdParty:boolean = false;
  isHorizontalRecentFileAccessedForPreview:boolean = false;
  cutCopiedFilesWithKeyboard:any =[];
  cutOrCopyOperationType: any = "";
  cutCopiedFilesWithKeyboardSource:any = "";
  cutCopiedFilesWithKeyboardDestination:any = "";
  enableTeamFolders:boolean = false;
  reBindingRequied:boolean = false;
  isPhoneVerification:boolean= false;
  mobileNoVerification:boolean = false;
  backupNoVerification:boolean = false;
  userHasCompletedOnBoardingFlow:boolean = false;
  showBlockingBannerModal:boolean = false;
  fullScreenBannerDetails:any;
  privateFolderHash:String ;
  encPrivateFolderHash:String ;
  header_X_PPF_TOKEN:any = '';
  passwordEncryptorUtil:any;
  isPrivateFolderTokenRequired:boolean = false;
  googleAuth2Instance:any;
  fileUploadMimeType:any = "";
  isPreviewFromRecentUpload:boolean = false;

  isFaceGroupingToggle:boolean = false;
  currentBackupDevice :any;
  currentSelectedDevice:any =[];
  iCloudBackup:boolean = false;
  
  public showDownTimeBanner:boolean = false;
  showDowntimeBannerModal:boolean = false;
  isDowntimeBannerModal:boolean = false;
  
  showDigiLockerAddtoJiocloudModal:boolean = false;
  public showCreateFolderAndUploadButtons:boolean = true;
  loadOnlyStatusPage:boolean = false;
  deviceType : any = "";

  isMemoryToggle:boolean = false;
  isJioPhoneCallRecordingToggleEnabled : boolean = false;

  private htmlAndDoctypeRegex = /<\/?[a-z][\s\S]*?>|<!DOCTYPE[^>]*>/gi;
  private urlRegex = /https?:\/\//gi;
  private lineBreakRegex = /[\r\n]+/g;
  isMultiLangNotSupported:boolean = false;
  invalidInvite:boolean = false;
  hideSizeColumn:boolean = false;
  showBoardPreviewStrip:boolean = false;
  eventUserFirstName:string = "";
  eventUserLasttName:string = "";
  eventUserEmail:string = "";
  eventId:string = "";
  waveRegister: boolean = true;
  //isWaveEvent: any = false;
  constructor(
    public translate: TranslateService,
    public router:Router,
    public http:HttpClient,
    private recalculateHeightService : ContainerHeightCalculatorService,
  ) { 
    this.passwordEncryptorUtil = new PasswordEncryptorUtil();
  }


  public subject = new BehaviorSubject<number>(0);
  removeDownloadItemFromList(item){
    setTimeout(()=>{
      let idx = this.downloadQueue.findIndex(x => x.key == item.key);
      if(idx>-1){
        this.downloadQueue.splice(idx,1);
        setTimeout(()=>{
          if(document.getElementById("uploadContainer")!=null){
            if(document.getElementById("downloadComponent")!=null) document.getElementById("uploadContainer").style.bottom = ''+document.getElementById("downloadComponent").getBoundingClientRect().height+'px'
            else document.getElementById("uploadContainer").style.bottom = '0'
          }
        })
      }
      if(this.downloadQueue.length==0) {
        AppEvents.globalObservable.next({closeDownloadProgressBar:true})
      }
    },5000)
  }

  millisToHourMinutesAndSeconds(miliSeconds){
    if(miliSeconds>3600000){//hh:mm:ss
      let hour= Math.floor(miliSeconds / 3600000);
      let min=Math.floor((miliSeconds - (hour*3600000))/60000)
      let sec=((miliSeconds - (hour*3600000)-(min*60000))/1000).toFixed(0)
      return hour+":"+(min<10?'0'+min:min)+":"+(parseInt(sec)<10?'0'+sec:sec)
    }else if(miliSeconds>60000){//mm:ss
      let min=Math.floor(miliSeconds/60000)
      let sec=((miliSeconds -(min*60000))/1000).toFixed(0)
      return (min<10?'0'+min:min)+":"+(parseInt(sec)<10?'0'+sec:sec)
    }else{
      let sec=(miliSeconds/1000).toFixed(0)
      return "00:"+(parseInt(sec)<10?'0'+sec:sec)
    }
  }

  disableModalBackdrop() {
    $(".highlight-recent-item").removeClass("highlight-recent-item");
    // Remove it (later)
    if(this.customerTroubleLogin){
      return;
    }else if(!this.mobileSelectionModeOn && this.isMobileDevice){
      this.clearSelection();
      if(this.popUpToBeOpened == 'deletePopUp' || this.popUpToBeOpened == 'shareLinkPopUp'){
        $('#custome_backdrop').remove();
      } else if(this.popUpToBeOpened == 'shareWithPeople'){
        $('#custome_backdrop').remove();
      } else{
        jQuery("[class*='modal-backdrop']").remove();
      }
    }else{  
      if(this.router.url == ('/')){
        return
      }
      var deleteModalElem = document.getElementById("delete-modal");
      var albumInfoElem =  document.getElementById("myAlbumSidenav");
      
      if(this.currentAlbum && albumInfoElem && deleteModalElem?.style.display == "none") {
        if((deleteModalElem?.style.display == "none") && (albumInfoElem?.style.display == "block"))
          this.showModalBackdrop();
        else
          $('#custome_backdrop').remove();
      } else
      if(!this.showFileInfo) {
        jQuery("[class*='modal-backdrop']").remove();
        $('#custome_backdrop').remove();
      }
    }

    if(this.isMobileDevice && this.showMobFileInfoPanel && this.showPreview){
      AppEvents.emit(EventsList.UPDATE_CONTEXT_MENU_ITEMS)
    }

  }


  showTransparentModalBackdrop() {
    // Show the backdrop
    jQuery('<div class="modal-backdrop transparent"></div>').appendTo(document.body);
  }

  showModalBackdrop(bindCloseModalFunc = true) {
    var self = this;
    // Show the backdrop
    $('#custome_backdrop').remove();
    jQuery('<div class="modal-backdrop" id="custome_backdrop"></div>').appendTo(document.body);
    if(bindCloseModalFunc) jQuery('.modal-backdrop').bind('click', {this: self}, this.closeOpenModals);
    setTimeout(()=>{
      if(this.popUpToBeOpened == 'deletePopUp'){
        let el = (document.querySelector('#m-delete-modal')) as any;
        let el_backdrop = (document.querySelector('#custome_backdrop') )as any;
        var zIndex1 = 1040 + (10 * $('.modal:visible').length);
        el.style.zIndex = zIndex1
        setTimeout(function() {
          el_backdrop.style.zIndex  = zIndex1 - 1;
        }, 0);
      }
    },10)
  }

  closeOpenModals(event) {
    var self = event.data.this;
    self.checkIsMandatory();

    if(self.isShowEmailVerifyModal || ((self.showShareWithPeople || self.showManageAccess || self.showEnhancedShareLink || self.isManageTeamFolderMembers) && self.isAnyChange)){
      if(self.showShareWithPeople || self.showFileInfo || self.showEnhancedShareLink || self.isManageTeamFolderMembers) {
        setTimeout(()=>{
          let ele = document.querySelector('.add-people-panel') as any
          ele.style.zIndex = '999';
          self.showModalBackdrop();
          self.popUpToBeOpened = 'shareDiscardPopUp';
        },100)
      }
      return
    }
    //self.selectedNodes = [];
    self.disableModalBackdrop();
    self.showFileInfo = false;
    self.uploadButtonClicked = false;
    self.isMobileShareOptionClicked = false;
    self.moreOptionsOnMobileClicked = false;
    self.showShareWithPeople = false;
    self.showEnhancedShareLink = false;
    self.showManageAccess = false;
    self.loadManageAccessComponent = false;
    self.showMobFileInfoPanel = false;
    if(self.showMobOptionMenu) {
      self.selectedNodes = [];
      self.clearSelection();
      self.showMobOptionMenu = false;
    }
    AppEvents.optionSelected.next({closeAll: true});
    AppEvents.memorySubscriptions.next({closeAll:true});
    AppEvents.memorySubscriptions.next({"decidetimer":true});
    AppEvents.teamFolderSubscription.next({closeAll: true});
    AppEvents.albumDetails.next({closeAll: true});
    AppEvents.globalObservable.next({closeAll:true});
    AppEvents.albumDetails.next({albumInfo: false});
    if($('.create-link-panel-main').is(":visible")) {
      jQuery(".create-link-panel-main").animate({"right":"-1000px"}, "200");
      jQuery(".create-link-panel-main").css({"opacity":"0"});
    }
  }

  checkIsMandatory(){
    const userId =  USER_DETAILS["USER_DETAILS"]["rootFolderKey"]
    let isMandatoryEmailActive = localStorage.getItem('isMandatoryEmailActive' + userId);
    if(isMandatoryEmailActive == 'true'){
      this.popUpToBeOpened = "dummy";
      this.isShowEmailVerifyModal = true;
    }
    /*else{
      this.isShowEmailVerifyModal = false
    }*/
  }

  clearSelection() {
    this.openMoreOptions = false;
    this.uploadButtonClicked = false;
    jQuery(".tab-content").find(".grid_info").removeClass("grid_info");
    jQuery(".tab-content").find(".list_info").removeClass("list_info");
  }


  showErrorMessage(error){
    console.log("error",error);
    if (error.status == 401) {
      if(this.activeRepo == "share"){
      this.router.navigate(['/signin']);
      localStorage.removeItem('jio');
      this.userLoggedIn = false;
      var ele = document.getElementById('parent');
      if(ele!=null)
        ele.setAttribute('style', "margin-left:175px");
      this.disableModalBackdrop();
      this.showModalBackdrop();
      }
    }
    else if(error.status == 400){
      if(error.error.code == 'NMSOM0200'){
        AppEvents.globalObservable.next({clearSession: true});
        AppEvents.optionSelected.next({closeAll: true});
        AppEvents.virtualDOMObservable.next({closeAll:true})
        AppEvents.memorySubscriptions.next({closeAll:true});
        AppEvents.globalObservable.next({closeAll:true});
        AppEvents.memorySubscriptions.next({"decidetimer":true});
        this.showToast(TOAST["Private_Folder_Error"],"error");
        this.router.navigate(['home']);
      }else if(error.error.code == "NMSCL0024") {
        this.showToast(TOAST["FILE_DOES_NOT_EXIST"],"error");
      }else if(error.error.code == "NMSCL0021") {
        this.showToast(TOAST["REQUEST_ACCESS"], "error");
      }else if(error.error.code == "NMSCL0082"){
        this.showToast(TOAST["SHARE_ACCESS_REVOKED"], "error");
      }else  if(error.error.code == "ENTC20183" ){
        this.showToast(TOAST["ENT_PLAN_DETAILS_UPDATE_FAILURE"], "error");
      }else if(error.error.code == "ENTC20184" ){
        this.showToast(TOAST["ENT_PLAN_DETAILS_UPADATE_FAILURE_ALLOCATED_EXCEEDS_PLAN_QUOTA"], "error");
      }else if(error.error.code == "ENTC20185" ){
        this.showToast(TOAST["ENT_PLAN_DETIALS_UPDATE_FAILURE_LICENCES"], "error");
      }else if(error.error.code == "ENTC20187" ){
        this.showToast(TOAST["USER_ACCOUNT_STATUS_ALREADY_UPDATED"], "error");
      }else if(error.error.code == "ENTC20188" ){
        this.showToast(TOAST["USER_ACCOUNT_STATUS_INVALID"], "error");
      }else if(error.error.code == "ENTC20195" ){
        this.showToast(TOAST["TRAIL_PLAN_NOT_FOUND"], "error");
      }
      else if(error.error.code == "ENTC20196" ){
        this.showToast(TOAST["INVALID_ENTERPRISE"], "error");
      }else if(error.error.code == "ENTC20197" ){
        this.showToast(TOAST["NOTHING_CHANGED"], "error");
      }else if(error.error.code == "ENTC20198" ){
        this.showToast(TOAST["INVALID_ADMIN_USER"], "error");
      }else if(error.error.code == "ENTC20199" ){
        this.showToast(TOAST["USER_INVALID_NOT_PART_OF_ENT"], "error");
      }else if(error.error.code == "ENTC20203" ){
        this.showToast(TOAST["ENT_OWNER_TO_BE_ADMIN"], "error");
      }else if(error.error.code == "ENTC20204" ){
        this.showToast(TOAST["TRAIL_PLAN_UPDATE_ERROR"], "error");
      } else if(error.error.code == "ENTC20205" ){
        this.showToast(TOAST["INVALID_PLAN"], "error");
      } 
      
      else if(error.error.code == "TFOM0020" || error.error.code == "TFOM0021" || error.error.code == "TFOM0035" || error.error.code == "NMSTF0021"){
        this.showToast(TOAST["TF_UNAUTHORIZED"], "error");
        if(this.inAppWebViewOpened) 
          return false;
        else if(this.router.url.includes('teamfolders') || this.router.url.includes('search/tf')){
          this.isAnyChange = false; // setting this to redirect user to team folder listing page when access rights are changed and user tries to perform operation
          this.showPreview = false; // setting this to deactivate current route and redirect user to team folder listing page when access rights are changed and user tries to perform operation
          AppEvents.optionSelected.next({closeAll: true});
          AppEvents.virtualDOMObservable.next({closeAll:true})
          AppEvents.globalObservable.next({closeAll:true});
          this.router.navigate(['teamfolders']);
        }
        else if(this.router.url.includes('allfiles')){
          AppEvents.optionSelected.next({closeAll: true});
          AppEvents.virtualDOMObservable.next({closeAll:true})
          AppEvents.globalObservable.next({closeAll:true});
          this.router.navigate(['allfiles']);
        }else {
          AppEvents.optionSelected.next({closeAll: true});
          AppEvents.virtualDOMObservable.next({closeAll:true})
          AppEvents.memorySubscriptions.next({closeAll:true});
          AppEvents.globalObservable.next({closeAll:true});
          AppEvents.memorySubscriptions.next({"decidetimer":true});
          this.router.navigate([this.router.url]);

        
        }
        
        
      } else if(error.error.code == "TFOM0038" ){
        this.showToast(TOAST["TF_PERMISSION_TYPE"], "error");
      } else if(error.error.code == "TFOM0031" ){
        this.showToast(TOAST["TF_ALREADY_EXIST"], "error");
      } else if(error.error.code == "TFOM0036" ){
        this.showToast(TOAST["TF_NOT_EXIST"], "error");
      } else if(error.error.code == "TFOM0037" ){
        this.showToast(TOAST["TF_CANNOT_DELETE"], "error");
      }
      else if((error.error.code == "BRSOM0420" || error.error.code == "SSOM0063" || error.error.code == "BRSOM0412") && !this.inAppWebViewOpened) {
        this.isServerError = true;
        setTimeout(function() {
          jQuery(".internal-server-error p").text("The file or folder is no longer available, it may have been deleted.");
        }, 10);
      }else{
        if(error.error?.code != "TEJVF0001") {
          this.showToast(TOAST["GENERIC_ERROR"],"error")
        }else{
          this.showToast(TOAST["INTERNAL_SERVER_ERROR"],"error");
  
        }
      }
      if(!this.isMobileDevice) {
        if(jQuery(".postlogin-leftnav-main").is(":visible")) {
          setTimeout(function() {
            jQuery(".internal-server-error .no-internet-main").css({
              "width" : "95%"
            });
          }, 10);
        } else {
          setTimeout(function() {
            jQuery(".internal-server-error .no-internet-main").css({
              "width" : "75%"
            });
          }, 10);
        }
      }
    } else if(error.status == 500){
      this.isServerError = true;
      this.showToast(TOAST["INTERNAL_SERVER_ERROR"],"error")
    }//else{
    //   this.showToast("Something went wrong, Please try again later!","error")
    // }
    if(this.inAppWebViewOpened) return false;
    this.showLoader = false;
  }

  showToast(message,state,emailId?){
    if(message == undefined || message.length == 0 )
      return;
    if(state == "success"){
      this.showSuccessToastMessage = true;
      this.showToastForWebViews();
      this.toastMessage = message;
      setTimeout(() => {
        this.showSuccessToastMessage = false;
        this.showViewButton = false;
        // this.MarkNewObjArray =[];
        this.viewButtonUrl = "";
        localStorage.removeItem(LocalStorageProps.UPLOAD_INITIATED_FOLDER)
        this.isUploadFromShare = false;
        this.isUploadFromRecentlyUploadedSection = false;
        this.hideToastForWebViews();
      },ENV_CONSTANTS["constants"]["intervalTime"])
    }else if(state == "error"){
      if(this.uploadStorageFullError){
        return
      }
      this.showErrorToastMessage = true;
      this.showToastForWebViews();
      this.toastMessage = message;
      setTimeout(() => {
        this.showErrorToastMessage = false;
        this.viewButtonUrl = "";
        this.hideToastForWebViews();
      }, ENV_CONSTANTS["constants"]["intervalTime"])
    }else if(state == "warning"){
      this.showWarningToastMessage = true;
      this.showToastForWebViews();
      this.toastMessage = message;
      setTimeout(() => {
        this.showWarningToastMessage = false;
        this.viewButtonUrl = "";
        this.hideToastForWebViews();
      }, ENV_CONSTANTS["constants"]["intervalTime"])
    }else if(state == "contactsearcherror"){
      this.showErrorToastMessage = true;
      this.toastMessage = message;
      setTimeout(() => {
        this.showErrorToastMessage = false;
        this.viewButtonUrl = "";
      }, ENV_CONSTANTS["constants"]["intervalTime"])
    }else if(state == "thirdpartysuccess"){
      this.showSuccessThirdPartyToastMessage = true;
      this.toastMessage = message;
      this.thirdPartyEmail = emailId;
      setTimeout(() => {
        this.showSuccessThirdPartyToastMessage = false;
      },ENV_CONSTANTS["constants"]["intervalTime"])
    }
    
  }

  showToastForWebViews(){
    if(this.inAppWebViewOpened){
      setTimeout(() => {
        $(".toast-main").show();
      }, 100);
    }
  }

  hideToastForWebViews(){
    if(this.inAppWebViewOpened){
      setTimeout(() => {
        $(".toast-main").hide();
      }, 100);
    }
  }

  closeToastMessage(){
    this.showSuccessToastMessage = false;
    this.showWarningToastMessage = false;
    this.showErrorToastMessage = false;
  }

  setUpdateProfileIconPath(){
    var profilePicUrl = USER_DETAILS["USER_DETAILS"]["profileIconPhotoPath"];
    if(!this.userLoggedIn || !profilePicUrl) return;
    var queryParams = new URL(profilePicUrl);
    var search_params = queryParams.searchParams;
    if(search_params.getAll('size').length > 1 || search_params.getAll('apiKey').length > 1 || search_params.getAll('devicetype').length > 1 || search_params.getAll('imgType').length > 1){
      search_params.delete('size');
      search_params.delete('apiKey');
      search_params.delete('devicetype');
      search_params.delete('imgType');
    }
    search_params.set('size','c');
    search_params.set('apiKey',ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"]);
    search_params.set('devicetype','web');
    if(this.isWebpSupported){
      search_params.set('imgType','webp');
    }
    queryParams.search = search_params.toString();
    profilePicUrl = queryParams.toString();
    this.profileIconPath = profilePicUrl
    AppEvents.updateAuthData.next({updateProperty:true,property:{"key":"profileIconPhotoPath","value":this.profileIconPath}});
    localStorage.setItem(LocalStorageProps.PROFILE_PHOTO_WITH_APIKEY, window.btoa(this.profileIconPath));
  }

  checkIfWebpIsSupported(callback){
    // var elem = document.createElement('canvas'); // this does not work on safari
    // if (!!(elem.getContext && elem.getContext('2d')))
    // {
    //   // was able or not to get WebP representation
    //   return elem.toDataURL('image/webp').indexOf('data:image/webp') == 0;
    // }
    // else
    // {
    //   // very old browser like IE 8, canvas not supported
    //   return false;
    // }
    var img = new Image();
    img.onload = function () {
        var result = (img.width > 0) && (img.height > 0);
        callback(result)
    };
    img.onerror = function () {
        callback(false)
    };
    img.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
  }


  checkIfGIFIsSupported(callback) {
    // force disable GIF starts
      // callback(false);
      // return;
    // force disable GIF ends
    var img = new Image();
    img.src = 'data:image/gif;base64,R0lGODlhAQABAIAAAAABAAMAAQAAACH5BAEAAAAALAAAAAABAAQAAAIaI+pyI7C8gIAAADs=';
    img.onload = function() {
      if (img.width !== 0 && img.height !== 0) {
        callback(true);
      } else {
        callback(false);
      }
    };
    img.onerror = function() {
      callback(false);
    };
  }
  
  openMobileTopMoreOptionMenu(){
    this.uploadButtonClicked = false;
    this.isMobileTopMoreOptionMenu = true;
    if(this.isMobileShareOptionClicked == false) {
      this.disableModalBackdrop();
    }
    AppEvents.globalObservable.next({"topMoreOptionsClicked":true})
  }


  clientDownloadBtnClick(){
    // clevertap.event.push("User_Screen_Tap", {
    //   "LOCATION":"Share_downlaod"
    // });
  }
  tosClicked(){
    // clevertap.event.push("User_Screen_Tap", {
    //   "LOCATION":"Share_T&C"
    // });
  }
  promoClicked(){
    // clevertap.event.push("User_Screen_Tap", {
    //   "LOCATION":"Share_promotion"
    // });
  }

  sharePublicSortSetting() { 
    var classRef = this;

    var localStorage = window.localStorage;
    
    if (localStorage.sharePublicSort == null || localStorage.sharePublicSort == undefined) {
      this.sharePublicSort = this.sharePublicSortByDate;
      //this.sharePublicSortOrder = this.sharePublicSortOrder;
      localStorage.setItem('sharePublicSort', this.sharePublicSort);
      //localStorage.setItem('sharePublicSortOrder', this.sharePublicSortOrder);

    } else {
      this.sharePublicSort = localStorage.sharePublicSort;
      //this.sharePublicSortOrder = localStorage.sharePublicSortOrder;
      localStorage.setItem('sharePublicSort', this.sharePublicSort);
      //localStorage.setItem('sharePublicSortOrder', this.sharePublicSortOrder);
    }
    let temp = "";
      if(this.sharePublicSort.includes("objectName")) {
        temp = "Name";
      } else if(this.sharePublicSort.includes("fileCreatedDate")) {
        temp = "Created Date";
      } else if(this.sharePublicSort.includes("createdDate")) { 
        temp = classRef.activeRepo == ActiveRepo.SHARE ?"Created Date":"Uploaded Date";
      } 
      return temp;
      // if(this.activeRepo == 'main' && temp!=""){
      //   classRef.sharePublicSortPropName = temp;
      // }

  }

  shareViewTypeSetting() {
    var classRef = this;
    var localStorage = window.localStorage;
    if(this.activeRepo == 'main'){
      if (localStorage.shareViewType == null || localStorage.shareViewType == undefined) {
        this.shareViewType = this.shareViewTypeGridName;
        localStorage.setItem('shareViewType', this.shareViewType);
      } else {
        if (localStorage.shareViewType == 'gridView') {
          this.shareViewType = this.shareViewTypeGridName;
          this.listView = false;
          localStorage.setItem('shareViewType', this.shareViewType);
        } else {
          this.shareViewType = this.shareViewTypeListName;
          this.listView = true;
          localStorage.setItem('shareViewType', this.shareViewType);
        }
      }
    }
    else{
      if (localStorage.shareRepoShareViewType == null || localStorage.shareRepoShareViewType == undefined) {
        this.shareViewType = this.shareViewTypeGridName;
        localStorage.setItem('shareRepoShareViewType', this.shareViewType);
      } else {
        if (localStorage.shareRepoShareViewType == 'gridView') {
          this.shareViewType = this.shareViewTypeGridName;
          this.listView = false;
          localStorage.setItem('shareRepoShareViewType', this.shareViewType);
        } else {
          this.shareViewType = this.shareViewTypeListName;
          this.listView = true;
          localStorage.setItem('shareRepoShareViewType', this.shareViewType);
        }
      }
    }
  }

  openPreview(object,showLatestVersion = true) {
    
    if(this.showMobilePlayList == true){
      this.showMobilePlayList = false;
    }
    if(object["horizontalItem"]) {
      this.recentFilesDataPreview = true;
    }
    if(this.isMobileDevice)
      this.switchOffMobileSelectionMode()

    // this.getCleverTapData();
    // var cleverTapSource = this.source;
    // jQuery("#more-options-thumbnails-modal").modal("hide");
    this.disableModalBackdrop();
    this.showMobOptionMenu = false;
    this.selectedNodes = [];
    if(!showLatestVersion){
      object["showLatestVersion"] = false;
    }else{
      object["showLatestVersion"] = true;
    }
    this.selectedNodes.push(object)
    // this.selectedFile = object;
    this.showPreview = true;
    this.showLoader = false;
    // clevertap.event.push("User_File_View", {
    //   "FILE_TYPE":object.format,
    //   "LOCATION":cleverTapSource
    // });
  }

  

  isFolderPresent(){
    var self = this;
    const isFolderPresent = this.selectedNodes.some(obj=> {
      var type = obj["FullObject"]?obj["FullObject"]["format"]:obj["format"];
      return type == "Folder"; 
    })
    self.showAddToJioCloudOnTopMenu = isFolderPresent ? false : true;  
  }


  checkIfImageAndVideosExistInSelection(){
    var self = this;
    const containsOtherTypeOtherThanImagesAndVideos = this.selectedNodes.some(obj=> {
      var type = obj["FullObject"]?obj["FullObject"]["format"]:obj["format"];
      return (type != "image" && type != "video"); 
    })
    return containsOtherTypeOtherThanImagesAndVideos ? false : true;  
  }

  haveEditAccess(){
    var self = this;
    const isHavingEditAccess = this.selectedNodes.some(obj=> {
      var editAccess = obj["FullObject"]?obj["FullObject"]["editAccess"]:obj["editAccess"];
      return editAccess == false; 
    })
    self.hasEditAccess = isHavingEditAccess ? false : true;  
  }

  

  thumbnailError(e){
    e.target.style.opacity = '0';
  }

  videoThumbnailError(e){
    e.target.style.opacity = '0';
    jQuery(e.target).parent().find('.video-icon').addClass("hide");
  }

  

  checkPage(){
    var url = window.location.href;
    if(url.includes('share?s=') || url.includes('?s') || url.includes('?u=')){
      this.activeRepo = 'share';
    }else if(url.includes('enterprise')){
      this.activeRepo = 'enterprise';
    }else{
      this.activeRepo = 'main';
    }
  }


  checkDeviceType() {
    
    this.checkiOSdevice();
    this.checkIsChromeOS();

    if (jQuery(window).width() < 992) {
      this.rowHeightTolerance = 0.50;
      this.isMobileDevice = true;
    } else {
      this.rowHeightTolerance = 0.25;
      this.isMobileDevice = false;
    }
  }

  checkiOSdevice() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window['MSStream'];
    this.iOSdevice = iOS;
  }

  checkIsChromeOS(){
    var chromeOS = /CrOS/.test(navigator.userAgent);
    this.chromeOS = chromeOS;
  }

  exitCurrentAlbum(){
    AppEvents.albumDetails.observers = [];
    this.uploadButtonClicked = false;
    this.showLoader = true;
    if(window.location.href.includes("/sharedalbums")){
      this.router.navigate(['/albums/sharedalbums']);
    }else{
      this.router.navigate(['/albums']);
    }
    this.selectedTab = "Albums"
    this.mobileSelectionModeOn = false;
    this.showTopMenu = false;
    this.selectedNodes = [];
  }


  // loadCorrespondingRoute(tabName){
  //   this.router.navigate([tabName]);
  // }

  

  showObjectInfo(file) {
    // this.getCleverTapData();
    // var cleverTapSource = this.source;
    this.disableModalBackdrop();
    this.showModalBackdrop();
    this.selectedFile = file;
    this.showInfoDetails = true;
    this.showMobFileInfoPanel = false;
    this.showContextMenu = false;
    jQuery("#customContextMenu").hide();
    if( this.selectedFile.objectType == "FR"){
      // clevertap.event.push("User_FolderInfo_View", {
      //   "SOURCE":cleverTapSource
      // });
    }else{
      // clevertap.event.push("User_FileInfo_View", {
      //   "ERROR":"SUCCESS",
      //   "SOURCE":cleverTapSource
      // });
    }
    //AppEvents.optionSelected.next({fileInfo: true});
  }


  showAlbumInfo() {
    // var cleverTapSource = this.source;
    this.disableModalBackdrop();
    this.showModalBackdrop();
    this.showFileInfo = true;
    this.showMobFileInfoPanel = false;
    this.showContextMenu = false;
    jQuery("#customContextMenu").hide();
    AppEvents.albumDetails.next({albumInfo: true});
    this.setAlbumInfoHeight();
  }

  setAlbumInfoHeight(){
    setTimeout(()=>{
      if(!this.isMobileDevice){
        let el = document.querySelector('#myAlbumSidenav .albums-info-inner') as any
        let height = (window.innerHeight- ($('#myAlbumSidenav  #desk-info-img-wrapper').innerHeight() + $('#myAlbumSidenav  #desk-info-header').innerHeight()+ 10)).toString() + 'px';
        el.style.height = height;
      }
    },300)
  }
  openMobileOptionMenu(file){
    this.disableModalBackdrop();
    this.showModalBackdrop();
    this.selectedFile = file;
    this.showMobOptionMenu = true;
  }


  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

  setWidthforLogin() {
    var id= (this.activeRepo == 'share')?'shared-parent':'parent';
    var ele = document.getElementById(id);
    if(ele != null || ele != undefined) {
      if (this.userLoggedIn) {
        // this.loggerService.log("setting parent margin-left 40px 888")
        if(this.iframeLogin){
          ele.setAttribute('style', "margin-left:0px;padding:0")
          return
        }
        ele.setAttribute('style', "margin-left:0px");
      } else {
        // this.loggerService.log("setting parent margin-left 175px 888")
        ele.setAttribute('style', "margin-left:185px")
      }
    }
  }
 
  moveArrayElement(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }
  
  openMobileFileInfo(file){  
    
    // var cleverTapSource = this.source;
    // for files uploaded via mobile, server response was not giving property shareKey separately as in case of desktop uploaded files, so extracting it from other metadata
    if(!file.shareKey){
      var url = file.url;
      if(url){
        var i = url.indexOf('shareKey')
        if(i>0){
          var temp = url.slice(i);
          var str = new URLSearchParams(temp);
          if(str.get('shareKey')){
            file.shareKey = str.get('shareKey')
          }
        }
      }
    }
    jQuery("#more-options-thumbnails-modal").modal("hide");
    
    this.disableModalBackdrop();
    this.showModalBackdrop();

    //this.showMobFileInfoPanel = true;
    this.showInfoDetails = true;
    this.showMobOptionMenu = false;
    this.selectedFile = file;
    this.showFileInfo = true;
    this.mobileSelectionModeOn = false;

    if( this.selectedFile.objectType == "FR"){
      // clevertap.event.push("User_FolderInfo_View", {
      //   "SOURCE":cleverTapSource
      // });
    }else{
      // clevertap.event.push("User_FileInfo_View", {
      //   "ERROR":"SUCCESS",
      //   "SOURCE":cleverTapSource
      // });
    }
    AppEvents.optionSelected.next({fileInfo: true});

  }

  openMobileAlbumInfo(){  
    jQuery("#more-options-thumbnails-modal").modal("hide");
    this.disableModalBackdrop();
    this.showModalBackdrop();
    this.showMobFileInfoPanel = true;
    this.showMobAlbumInfoPanel = true;

    this.showMobOptionMenu = false;
    this.showFileInfo = false;
    AppEvents.albumDetails.next({albumInfo: true});
  }


  highlightActiveMenu(removeClassName, focussedClassName) {
    var elems = document.querySelector(removeClassName);
    if(elems !==null){
     elems.classList.remove(focussedClassName);
   }
  }

  togglePublicSort(sortType,reverseOrder:boolean = false) {  
    var classRef = this;
    // if(classRef.sharePublicSortOrder == "%2D"){
    //   classRef.sharePublicSortOrder = "%2B";
    // }else{
    //   classRef.sharePublicSortOrder = "%2D";
    // }
    let temp="";
      
    if(reverseOrder){
      if(classRef.sharePublicSort.includes("%2D")){
        classRef.sharePublicSort = classRef.sharePublicSort.replace("%2D","%2B");
      }else{
        classRef.sharePublicSort = classRef.sharePublicSort.replace("%2B","%2D");
      }
    }else{
      let sortingOrder="%2D";
      if(classRef.isMobileDevice){
        if(sortType.includes("objectName")) 
          sortingOrder="%2B";
        else if(sortType.includes("Date")) 
          sortingOrder="%2D";
      }else{
        if(classRef.sharePublicSort.includes("%2B")){
          sortingOrder = "%2B";
        }
      }
      if(this.activeRepo == ActiveRepo.MAIN){
        if(sortType.includes("objectName")) {
          classRef.sharePublicSort = sortingOrder + "objectName";
          temp = "Name";
        } else if(sortType.includes("fileCreatedDate")) {
          classRef.sharePublicSort = sortingOrder + "fileCreatedDate";
          classRef.sharePublicSortByDate = sortingOrder + "fileCreatedDate";
          temp = "Created Date";
        } else if(sortType.includes("createdDate")) {
          classRef.sharePublicSort = sortingOrder + "createdDate";
          classRef.sharePublicSortByDate = sortingOrder + "createdDate";
          temp = classRef.activeRepo == ActiveRepo.SHARE ?"Created Date":"Uploaded Date";
          classRef.sharePublicSortByUploadDate = sortingOrder + "createdDate";
        } else {
          classRef.sharePublicSort = sortingOrder + "fileCreatedDate";
          temp = "Created Date";
        }
      }else if(this.activeRepo == ActiveRepo.SHARE){
        if(sortType.includes("objectName")) {
          classRef.sharePublicSort =   "%2BobjectName";
          temp = "Name";
        } else if(sortType.includes("createdDate")) {
          classRef.sharePublicSort = "%2DcreatedDate";
          temp = "Created Date";
        }
      }
    }
    
      // if(this.activeRepo == 'main'){
      //   classRef.sharePublicSortPropName = temp;
      // }
    if( classRef.sharePublicSort.includes("Date")){
      classRef.sharePublicSortByDate = classRef.sharePublicSort;
    }
    
    localStorage.setItem('sharePublicSort', this.sharePublicSort);
    return temp;
  }

  getCurrentSortType(sortType) {
    if(sortType.includes("objectName")) {
      return "Name";
    } else if(sortType.includes("fileCreatedDate")) {
      return "Created Date";
    } else if(sortType.includes("createdDate")) { 
      return "Uploaded Date";
    } else {
      return "Created Date";
    }
  }

  toggleView() {
    var classRef = this;
    this.mobileSelectionModeOn = false;
    if(this.activeRepo == 'main'){
      localStorage.setItem('shareViewType', classRef.shareViewType);
    }
    else{
      localStorage.setItem('shareRepoShareViewType', classRef.shareViewType);
    }
  }

  getCleverTapData(){

    if(this.currentTab == "allfilesTab" && this.insideFolder != true){
      this.source = "Allfiles"
    }else if(this.currentTab == "audio"){
      this.source = "Audio"
    }else if(this.currentTab == "videos"){
      this.source = "Videos"
    }else if(this.currentTab == "doc"){
      this.source = "Documents"
    }else if(this.currentTab == "photos"){
      this.source = "Photos"
    }else if( this.currentTab == 'allfiles' && this.insideFolder == true){
      this.source = "Folder"
    }
  }



  public setThemeAppearance(themeAppearance) {
    this.themeAppearance = themeAppearance;
  }

  public getThemeAppearance() {
    return this.themeAppearance;
  }


  public setThemeLanguage(lang) {
    this.lang = lang;
  }

  public getThemeLanguage() {
    return this.lang;
  }

  public initThemeLanguage(translate) {
    let currentLang = this.getThemeLanguage();
    if (localStorage.getItem('userPrefLanguage') !== null) {
      if((localStorage.getItem('oldUserPrefLanguage'))&&(localStorage.getItem('userPrefLanguage') != localStorage.getItem('oldUserPrefLanguage'))){
        currentLang = localStorage.getItem('oldUserPrefLanguage');
      }
      else{
        currentLang = localStorage.getItem('userPrefLanguage');
      }
    }
    
    this.setThemeLanguage(currentLang);
    translate.setDefaultLang(currentLang);
  }

  initTheme() {
    
    let htmlElem = document.querySelector('html');
    htmlElem.setAttribute('data-theme', THEMES.THEME_LIGHT);
    this.isDarkTheme = false;

    // this.watchOsThemeMode();
    // this.setLocalizedSunsetSunrise();

    // let themeSwitchElem = document.getElementById('switchThemeAppearance') as HTMLInputElement;
    // this.isDarkTheme = (localStorage.getItem('userPrefAppearance') !== null && localStorage.getItem('userPrefAppearance') === THEMES.THEME_DARK);

    // let htmlElem = document.querySelector('html');
    // if (localStorage.getItem('userPrefAppearance') !== null) {
    //   this.isDarkTheme ? htmlElem.setAttribute('data-theme', THEMES.THEME_DARK) : htmlElem.setAttribute('data-theme', THEMES.THEME_LIGHT);
    //   themeSwitchElem.checked = this.isDarkTheme;
    // } else {
    //   this.toggleThemeAppearanceButton();
    // }
  }

  toggleThemeAppearanceButton() {
    
    let themeSwitchElem = document.getElementById('switchThemeAppearance') as HTMLInputElement;
    this.isDarkTheme = (this.getThemeAppearance() === THEMES.THEME_DARK);
    themeSwitchElem.checked = this.isDarkTheme;
  }

  watchOsThemeMode() {
    let htmlElem = document.querySelector('html');


    if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.setThemeAppearance(THEMES.THEME_DARK);

    } else if (window.matchMedia('(prefers-color-scheme: light)').matches) {
      this.setThemeAppearance(THEMES.THEME_LIGHT);
    }

    htmlElem.setAttribute('data-theme', this.getThemeAppearance());

    window.matchMedia('(prefers-color-scheme: dark)').addListener(e => {
      if (localStorage.getItem('userPrefAppearance') !== null) {
        return false;
      }
      if (e.matches) {
        this.setThemeAppearance(THEMES.THEME_DARK);
      } else {
        this.setThemeAppearance(THEMES.THEME_LIGHT);
      }
      htmlElem.setAttribute('data-theme', this.getThemeAppearance());
      this.toggleThemeAppearanceButton();
    });
  }

  setLocalizedSunsetSunrise() {
    let classRef = this;
    let today = new Date().getHours();
    if (today >= SUNSET_SUNRISE.SUNRISE && today < SUNSET_SUNRISE.SUNSET) {
      // this.loggerService.log("Enable Light mode :: " + today);
      classRef.setThemeAppearance(THEMES.THEME_LIGHT);
    } else {
      // this.loggerService.log("Enable Dark mode :: " + today);
      classRef.setThemeAppearance(THEMES.THEME_DARK);
    }

    let htmlElem = document.querySelector('html');
    htmlElem.setAttribute('data-theme', classRef.getThemeAppearance());
  }
  switchOffMobileSelectionMode(){
    this.mobileSelectionModeOn = false;
    this.selectedNodes = [];
    AppEvents.virtualDOMObservable.next({closeAll:true})
    $('.listItem').removeClass('list_info');
    $('.gridItem').removeClass('grid_info');
    this.disableModalBackdrop();
    setTimeout(() => {
      this.recalculateHeightService.sendRecalculateEventToComponents(true);
    }, 10);
  }

  removeEventListeners(){
    this.selectedTab = '';
    AppEvents.removeAllEventListener(EventsList.TAB_CLICKED);
    AppEvents.removeAllEventListener(EventsList.TABBED_VIEW_READY);
    AppEvents.removeAllEventListener(EventsList.MYFILES_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.FAVORITES_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.EMPTY_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.SHARED_FILES_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.ALBUM_LIST_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.ENT_MEMBER_TEAMS_FOLDER_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.ENT_ADMIN_TEAMS_FOLDER_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.ENT_VIEWER_TEAMS_FOLDER_TABBED_VIEW);
  }

  removePopUpEventListeners(){
    AppEvents.removeAllEventListener(EventsList.POP_UP_TAB_CLICKED);
    AppEvents.removeAllEventListener(EventsList.COPY_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.DECIDE_TO_ENABLE_BUTTON);
    AppEvents.removeAllEventListener(EventsList.ADD_TO_ALBUM_MODAL_TABBED_VIEW);
    AppEvents.removeAllEventListener(EventsList.POPUP_TABBED_VIEW_READY)
  }

 
  setAnimationStatus(route){
    if(this.isMobileDevice){
      setTimeout(()=>{
        let el = '#' + route;
        let bar = (document.querySelector('.nav-active-bar')) as any;
        var p = document.getElementById(route);
        if(p && bar != undefined){
          let top = p.offsetTop;
          let height = p.clientHeight;
          bar.style.top = top + "px" ;
          bar.style.height = height + "px" ;
        }
      },450);
    }else{
      this.isMenuItemSelected(route)
    }
  }

  /**
     * show time in below format :
     * Time < 1 min = convert to seconds (Xs)​
     * Time >= 1 min  and Time <1 Hour= convert to minutes (Xm)​
     * Time >= 1 Hour and Time < 24 Hours =  convert to hours (Xh)​
     * Time >= 24 Hours  = show Actual date (DD Mon YYYY)​
     */
    showTimeInFormat(timeToFormat, textToAppend, currentTimeToUse) {
      var currentTime = new Date().getTime();
      if(currentTimeToUse != undefined && currentTimeToUse != null) {
        currentTime = currentTimeToUse;
      }
      var timeDiff = (currentTime - timeToFormat);
      if(timeDiff < DATE_TIME_DURATION.DURATION_ONE_MINUTE) {
          //seconds
          if (Math.floor(timeDiff/1000) > 1) {
              return Math.floor(timeDiff/1000) + " sec " + textToAppend;
          } else {
              return "Just Now";
          }
      } else if(timeDiff >= DATE_TIME_DURATION.DURATION_ONE_MINUTE && timeDiff < DATE_TIME_DURATION.DURATION_ONE_HOUR) {
          //minutes
          return Math.floor(timeDiff/DATE_TIME_DURATION.DURATION_ONE_MINUTE) + " min " + textToAppend;
      } else if(timeDiff >= DATE_TIME_DURATION.DURATION_ONE_HOUR && timeDiff < DATE_TIME_DURATION.DURATION_ONE_DAY) {
          // hours
          return Math.floor(timeDiff/DATE_TIME_DURATION.DURATION_ONE_HOUR) + " hr " + textToAppend;
      } else { // if(timeDiff >= this.DURATION_ONE_DAY) {
          //date
          var dateToFormat = new Date(timeToFormat);
          return (dateToFormat.getDate() + " " + this.SHORT_MONTH_NAMES[dateToFormat.getMonth()] + " " + dateToFormat.getFullYear());
      }
  }

  resetValuesBeforeReLogin() {
    var classRef = this;
    classRef.showFileInfo = false;
//!classRef.userLoggedIn && classRef.showPreview &&
    if( classRef.showPreview &&  !(this.popUpToBeOpened == "addToJioCloud" || this.openCreateShareLink)){// !window.location.href.includes("?u")
      classRef.showPreview = false;
    }
    if(classRef.popUpToBeOpened != "addToJioCloud"){
      classRef.popUpToBeOpened = "";
    }
    classRef.openFolderContent = false;
    classRef.showTopMenu = false;
    classRef.hideTopMenuOptions();  
    classRef.showShareWithPeople = false;
    classRef.showEnhancedShareLink = false;
    classRef.userLandingLoggedIn = false;
    classRef.showMiniPlayer = false;
    classRef.isMobileTopMoreOptionMenu = false;
    classRef.isShowEmailVerifyModal = false;
    classRef.profileIconPath = "";
    if(!classRef.isUnivSharelink) {
      classRef.sortByNameArray =[];
      classRef.sortByDateArray = [];
      classRef.foldersArray = [];
    }
    classRef.recentFilesPreviewArray = [];
    classRef.recentAlbumSCFilesPreviewArray = [];
    classRef.showPassPhraseReset = false;
    classRef.isDisable2FAInprocess = false;
    classRef.isPassphraseReset = false;

    classRef.recoverVerifyOTPpopUp =  false;
    classRef.showRecoverpopUp = false;
    classRef.showRecoverVerifyemailpopUp = false;
    classRef.customerTroubleLogin = false;
    classRef.show2FApopUp = false;
    if(this.player!=undefined && this.player!=null){
      this.player.stop();
      this.player.destroy();
    }
    // if(this.clapprImpl.audioplayer!=undefined && this.clapprImpl.audioplayer!=null){
    //   this.clapprImpl.audioplayer.stop();
    //   this.clapprImpl.audioplayer.destroy();
    // }

  }

  stopAndCloseAudioPlayer() {
    if(this.player!=undefined && this.player!=null){
      this.player.stop();
      this.player.destroy();
    }
    this.showMiniPlayer = false;
  }

  showTopMenuOptions(){
    $('#more-options-tab-inline-main').css('display', 'flex');  
  }

  hideTopMenuOptions(){
    $('#more-options-tab-inline-main').hide();  
  }

  msToTime(milliseconds) {
    var hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    // hour = Math.floor(minute / 60);
    // minute = minute % 60;
    // hour = hour % 24;
    return {
        hour: 0,
        minute: minute,
        seconds: seconds
    };
  }

  fetchContextMenu(){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(ENV_CONFIG.jsonUrls.contextMenu).subscribe(
        suc=>{
          if(window.location.href.includes("?u")){
            self.contextMenu_Share = suc["SHARE_PUBLIC_REPO"];
          }else{
            self.contextMenu_Share = suc["SHARE_REPO"];
          }
          self.contextMenu_MainRepo = suc["MAIN_REPO"];
          self.myFiles_default_ContextMenu = suc["MYFILES_DEFAULT_CONTEXT_MENU"];
          self.albums_default_ContextMenu = suc["ALBUMS_DEFAULT_CONTEXT_MENU"]
            
          resolve(suc);
        },
        err=>{
            reject(err);
        }
      )
    })
  }
  fetchTopMenu(){
    var self = this;
    return new Promise(function(resolve,reject){
      self.http.get(ENV_CONFIG.jsonUrls.topMenu).subscribe(
        suc=>{
          if(window.location.href.includes("?u")){
            self.topMenu_Share = suc["SHARE_PUBLIC_REPO"];
          }else{
            self.topMenu_Share = suc["SHARE_REPO"];
          }
          self.topMenu_MainRepo = suc["MAIN_REPO"];
          resolve(suc);
        },
        err=>{
            reject(err);
        }
      )
    })
  }

  async fetchJSONContent(fetchAll=true){
    if(window.location.href.includes('/searchdetails')){
      return
    }
    var self = this;
    if(this.isMobileDevice){
      this.http.get(ENV_CONFIG.jsonUrls.topMenuMobile).subscribe( // fetch top menu mobile
        suc=>{
          if(window.location.href.includes("?u")){
            self.topMenuMobile_Share = suc["SHARE_PUBLIC_REPO"];

          }else{
            self.topMenuMobile_Share = suc["SHARE_REPO"];
          }
          self.topMenuMobile_MainRepo = suc["MAIN_REPO"];
          self.topMenuMobile = suc;
        }
      )
    }
    else{
      await self.fetchContextMenu();
      await self.fetchTopMenu();
    }
    if(!fetchAll) return;
    this.http.get(ENV_CONFIG.jsonUrls.fileInfo).subscribe( // fetch file info menu
      suc=>{
        self.FileInfo = suc;
      }
    )
    self.fetchLeftMenuJSONContents();
    self.fetchEntListHeaderJSONContents();
    self.fetchEntMoreOtionJSONContents();
  }

  fetchLeftMenuJSONContents(){
    var self = this;
    let menuUrl = '';
    if(self.isMobileDevice){
      menuUrl = ENV_CONFIG.jsonUrls.leftMenu
    }else{
      let url = window.location.href;
      if((!localStorage.jio && (url.includes('?s') || url.includes('?u='))) || self.iframeLogin){
        menuUrl = ENV_CONFIG.jsonUrls.leftMenu
      }else{
        menuUrl = ENV_CONFIG.jsonUrls.newLeftMenu
      }
    }
    self.http.get(menuUrl).subscribe(
      suc=>{
        self.leftMenu = suc;
        AppEvents.globalObservable.next({"leftMenuContents":true});
      }
    )
  }
  isMenuItemSelected(id) {
    if(!this.isMobileDevice){
      if((id == 'PrivateFolder' && !this.router.url.includes('privatefolder'))){
        return
      }
      if(window.location.href.includes('?u=') || id == 'userprofile'){
        let elArray = document.querySelectorAll('.left-menu-selected-item')
        elArray.forEach(e =>{
          if(e){
            e.classList.remove('left-menu-selected-item')
          }
        });
        return
      }
      let elArray = document.querySelectorAll('.left-menu-selected-item')
      elArray.forEach(e =>{
        if(e){
          e.classList.remove('left-menu-selected-item')
        }
      });
      setTimeout(()=>{
        let elId = id
        let el = document.getElementById(elId)
        if(el){
          el.classList.add('left-menu-selected-item');
        }
      },450)
    }
  }
  checkInternetConnection() {
    var classRef = this;
    // var url = '/favicon.ico?_' + Date.now();
    var url = '/favicon.ico?_' + Date.now();

    return new Promise(function(resolve, reject) {

      var httpRequest = new XMLHttpRequest();
      httpRequest.open('GET', url, true);
      httpRequest.ontimeout = function () {
          reject("" + httpRequest.responseText);
      };
      httpRequest.onreadystatechange = function () {
          if (httpRequest.readyState === XMLHttpRequest.DONE) {
              if (httpRequest.status >= 200 && httpRequest.status < 304) {
                  resolve(true);
              } else {
                resolve(false);
              }
          }
      };

      httpRequest.send();
    });
  }
  
  entMoreOption:any;
  entListHeader:any;
  fetchEntMoreOtionJSONContents(){
    var self = this;
    this.http.get(ENV_CONFIG.jsonUrls.entMoreOption).subscribe(
      suc=>{
        self.entMoreOption = suc;
      }
    )
  }
  fetchEntListHeaderJSONContents(){
    var self = this;
    this.http.get(ENV_CONFIG.jsonUrls.entListHeader).subscribe(
      suc=>{
        self.entListHeader = suc;
      }
    )
  }

  // Team folder roleCode based on userRight property
  decideTFRoleCodeOnUserRights(object) {
    var roleCode = "";
    if(object && object.userRight) {
      var userRights = object.userRight;
      if(userRights.canEdit == false && userRights.canView == true && userRights.canCopy == true && userRights.canViewTrash == true && userRights.canRename == false && userRights.canDelete == false) {
        roleCode = "V"; //Viewer
      } else if(userRights.canEdit == true && userRights.canView == true && userRights.canCopy == true && userRights.canViewTrash == true && userRights.canRename == true && userRights.canDelete == true) {
        roleCode = "E"; //Editor
      } else if(userRights.canEdit == true && userRights.canView == true && userRights.canCopy == true && userRights.canViewTrash == true) {
        roleCode = "O"; //Owner
      }
      return roleCode;
    }
  }
  //Decide current object view 
  getCurrentViewOfObjects() {
    var url = window.location.href;
    var viewScreen = "";
    if(url.includes("sharedwithme")){
      viewScreen = "share"
    } else if(url.includes("teamfolder")){
      viewScreen = "teamfolder"
    }else{
      viewScreen = "repo"
    }
    return viewScreen;
  }
  highlightSelectedOption(id){
    $('#'+id).addClass('highlightOption');
    if(this.showPreview){
      $(".preview-options-tab-inline-main #" + id).addClass('highlightOption');
    }
  }

  removeHighlightFromSelectedOption(){
    jQuery(".main-wrapper").find(".highlightOption").removeClass("highlightOption");
  }

  async getPPFToken22(userId,pfPassword,privateFolderSessionKey){ 
   	let currentTime = new Date();
    let ppfHash = this.passwordEncryptorUtil.getHash(userId, pfPassword);////userId,passPhrase
    let StringToEncrypt = userId + '#' + ppfHash+ '#' + currentTime.getTime();
    this.header_X_PPF_TOKEN = await this.passwordEncryptorUtil.encryptPassPhrase(StringToEncrypt, privateFolderSessionKey)
   // return this.header_X_PPF_TOKEN
  }


  pauseMemoryTimer(){
    AppEvents.memorySubscriptions.next({"pausetimer":true});
  }

  resumeMemoryTimer(){
    AppEvents.memorySubscriptions.next({"resumetimer":true});
  }

  decideMemoryTimer(){
    AppEvents.memorySubscriptions.next({"decidetimer":true});
  }

  generateRowIndexes(count: number): Array<number> {
    let skeletonArrayCount = [];
    for (let i = 0; i < count; i++) {
      skeletonArrayCount.push(i);
    }
    return skeletonArrayCount;
  }

  checkIfAnyModalIsOpen(){
    let openModalList = document.querySelectorAll('.modal.fade');
    let openModalListWhichAreNotUsingModalFade = Array.prototype.slice.call(document.querySelectorAll('.modal-popup'));
    let modalsList = Array.prototype.slice.call(openModalList).concat(openModalListWhichAreNotUsingModalFade)
    const isModalOpen = modalsList.some(modal=> {
      let style = window.getComputedStyle(modal)
      return (style.getPropertyValue('display') == 'block' || (document.getElementById('advc-search') == document.activeElement));
    })
    if(isModalOpen){
      return true;
    }
    return false;
  }


  isBrowserSupported(){
    let browserDetails = Bowser.parse(window.navigator.userAgent);
    let browserName = browserDetails.browser["name"];
    if(!browserDetails) return false;
    this.deviceType = browserDetails["os"]["name"];
    if(ENV_CONFIG["BROWSER_SUPPORT"][browserName]){
      let versionsList = browserDetails["browser"]["version"].split('.');
      if(parseInt(versionsList[0]) < ENV_CONFIG["BROWSER_SUPPORT"][browserName]["major"]){
        return false;
      } else if((parseInt(versionsList[0]) == ENV_CONFIG["BROWSER_SUPPORT"][browserName]["major"]) && (parseInt(versionsList[1]) < ENV_CONFIG["BROWSER_SUPPORT"][browserName]["minor"])){
        return false;
      }
      return true;
    }else{
      return false;
    }
  }

  decideLayoutType(data) {
    let layoutType = '';
    if(this.isMobileDevice){
      layoutType = data['mlayout'] ? data["mlayout"] : 'non-virtual';
      this.virtualGridEnabled = layoutType == 'non-virtual' ? false : true;
    }else{
      layoutType = data['dlayout'] ? data["dlayout"] : 'non-virtual';
      this.virtualGridEnabled = layoutType == 'virtual' ? true  : false;
    }
  }

  checkIfImgTypeParamIsRequired(mimeSubType){
    if(mimeSubType == "gif"){
      return this.renderGifThumbnails(mimeSubType);
    }
    let format = mimeSubType == "gif" ? 'gif' : "webp";
    let checkIfImgTypeIsRequiredInUrl = format == "gif" ? this.isGIFSupported : this.isWebpSupported;
    let type = checkIfImgTypeIsRequiredInUrl ? "&imgType=" + format : "";
    return type;
  }
  renderGifThumbnails(mimeSubType){
    let checkIfImgTypeIsRequiredInUrl =  this.isWebpSupported;
    let type = checkIfImgTypeIsRequiredInUrl ? "&imgType=webp" : "";
    if(checkIfImgTypeIsRequiredInUrl){
      type += "&anim=1";
    }    
    return type;
  }

}


export enum ActiveRepo {
  MAIN = "main",
  SHARE = "share",
  INVITE = "invite",
  ENTERPRISE = "enterprise"
}

export enum ShareType {
  PUBLIC = "P",
  RESTRICTED = "R"
}

export enum ShareAccessRole {
  VIEWER = "V",
  EDITOR = "E"
}

export enum RecipientRole {
  VIEWER = "V",
  EDITOR = "E"
}

export enum RecipientOperations {
  ADD = "A",
  UPDATE = "U",
  REMOVE = "R",
}

export enum RecipientActions {
  V = "Can Read",
  E = "Can Edit",
  R = "Remove"
}

export enum RecipientAccess {
  V = "Can View",
  E = "Can Edit",
  R = "Remove Access"
}

export enum TeamFolderAccess {
  V = "Viewer",
  E = "Editor",
  O = "Owner"
}

export enum DigiLockerDocumentsType {
  DRVLC = "Driving License",
  PANCR = "PAN Card",
  ADHAR = "Aadhaar Card"
}

export enum VersionModuleType {
  MY_FILES = "MyFiles",
  ALBUMS = "Albums",
  SHARED_FILES = "SharedFiles",
  TEAM_FOLDERS = "TeamFolders"
}

export enum DATE_TIME_DURATION {
  //Time duration
  DURATION_ONE_MINUTE = 60 * 1000,
  DURATION_ONE_HOUR = 60 * 60 * 1000,
  DURATION_ONE_DAY = 24 * 60 * 60 * 1000,
  
}

export enum KEY_CODE {
  RIGHT_ARROW = 39,
  LEFT_ARROW = 37,
  SPACE = 32,
}

export enum CUT_COPY_OPERATION {
  MOVE = "MOVE",
  COPY = "COPY"
}

export enum WRAPPER_TYPE {
  MY_FILES_OPERATIONS = "MY_FILES_OPS_WRAPPER",
  NO_OPERATIONS = "NO_OPERATIONS_WRAPPER",
  ENHANCE_SHARE_OPERATIONS = "ENHANCED_SHARE_OPS_WRAPPER",
  PEOPLE_TAB_OPERATIONS = "PEOPLE_OPS_WRAPPER",
  ALBUMS_OPERATIONS  = "ALBUMS_OPS_WRAPPER",
  PRIVATE_FOLDER_OPERATIONS = "PRIVATE_FOLDER_OPERATIONS",
  DIGI_LOCKER_OPERATIONS = "DIGILOCKER_OPERATIONS",
  JIO_PHONE_CALL_RECORDING_OPERATIONS = "JIO_PHONE_CALL_RECORDING_OPERATIONS"
}